import type { SxProps, Theme } from '@mui/material';
import { autocompleteClasses } from '@mui/material/Autocomplete';

export const autocompleteVirtualizationPopperSx: SxProps<Theme> = {
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    '& ul': {
      margin: 0,
      padding: 0,
    },
  },
};
